import React, { Component } from "react";
import FormControl from '@mui/material/FormControl';
import SessionStateManager from "@components/SessionStateManager";
import ValidationsManager from "@components/ValidationsManager";
import UpdateDialog from '@components/UpdateDialog';
import SupportAlert from "@components/SupportAlert";
import { CustomDialog, useDialog } from 'react-st-modal';
import styles from '../questionnaire.module.css';

class BooleanRadioQuestion extends Component {
    state = {
        loading: true,
        sessionStateChanged: false,
    }

    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        this.setState({ loading: true });

        this.setState({ loading: false });
    }

    async handleChange(evt) {
        let key = evt.target.attributes.questionFactId.value + '_' + evt.target.attributes.ordinalEntry.value;
        let value = evt.target.value;

        if (this.props.captureType !== undefined && this.props.captureType !== null && this.props.captureType == 'RESEARCHER_UPDATE') {
            const result = await CustomDialog(
                <UpdateAuditDialog
                    currentAnswer={SessionStateManager.getSessionValue(key)}
                    booleanType={'radio'}
                />,
                {
                    className: styles.updateAuditDialog,
                    title: 'Update Submitted Value',
                    showCloseIcon: false,
                    isFocusLock: true,
                    isCanClose: true, // setting this to false prevents the dialog from being closed when clicking away
                }
            );

            if (result !== undefined && result !== null && result.confirmed !== undefined && result.confirmed !== null && result.confirmed == true) {
                SessionStateManager.setSessionValue(key, result.newValue, this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, result.sourceOfData, result.reason);
                this.setState({ sessionStateChanged: true });
            } else {
                evt.preventDefault();
            }
        } else {
            SessionStateManager.setSessionValue(key, value, this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
            this.setState({ sessionStateChanged: true });
        }

        if (this.props.onChange !== undefined && this.props.onChange !== null) {
            this.props.onChange(evt);
        }

    }

    render() {
        if (this.state.loading === true) {
            return <p>Loading...</p>
        } else {
            let notNull = SessionStateManager.getSessionValue(this.props.questionState.questionFactStates[0].questionFactId + '_0') !== null;
            let isChecked = JSON.parse((SessionStateManager.getSessionValue(this.props.questionState.questionFactStates[0].questionFactId + '_0') !== undefined
                && SessionStateManager.getSessionValue(this.props.questionState.questionFactStates[0].questionFactId + '_0') !== null
                && SessionStateManager.getSessionValue(this.props.questionState.questionFactStates[0].questionFactId + '_0') !== '')
                ? SessionStateManager.getSessionValue(this.props.questionState.questionFactStates[0].questionFactId + '_0') : 'false');

            if (this.props.orientation.toUpperCase() == 'VERTICAL') {
                return <FormControl
                    className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.props.questionState.questionFactStates[0].questionFactId + '_0') ? styles.checkboxUpdated : styles.checkbox}
                    component="fieldset">
                    <div class="radio-group">
                        <div>
                            <input
                                class="radio"
                                type="checkbox"
                                id={"checkbox_yes_q" + this.props.questionState.question.id + 'qf' + this.props.questionState.questionFactStates[0].questionFactId}
                                checked={notNull && isChecked}
                                ordinalEntry={0}
                                questionFactId={this.props.questionState.questionFactStates[0].questionFactId}
                                onChange={(evt) => this.handleChange(evt)}
                                value={true}
                                questionId={this.props.questionState.question.id}
                            />
                            <label for={"checkbox_yes_q" + this.props.questionState.question.id}>Yes &nbsp;&nbsp;&nbsp;</label>
                        </div>
                        <div>
                            <input
                                class="radio"
                                type="checkbox"
                                id={"checkbox_no_q" + this.props.questionState.question.id + 'qf' + this.props.questionState.questionFactStates[0].questionFactId}
                                checked={notNull && !isChecked}
                                ordinalEntry={0}
                                questionFactId={this.props.questionState.questionFactStates[0].questionFactId}
                                onChange={(evt) => this.handleChange(evt)}
                                value={false}
                                questionId={this.props.questionState.question.id}
                            /> <label for={"checkbox_no_q" + this.props.questionState.question.id}>No </label>
                        </div>
                    </div>
                </FormControl>
            } else {
                return <FormControl
                    className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.props.questionState.questionFactStates[0].questionFactId + '_0') ? styles.checkboxUpdated : styles.checkbox}
                    component="fieldset">
                    <div
                        class="radio-group">
                        <input
                            class="radio"
                            type="checkbox"
                            id={"checkbox_yes_q" + this.props.questionState.question.id + 'qf' + this.props.questionState.questionFactStates[0].questionFactId}
                            checked={notNull && isChecked}
                            ordinalEntry={0}
                            questionFactId={this.props.questionState.questionFactStates[0].questionFactId}
                            onChange={(evt) => this.handleChange(evt)}
                            value={true}
                            questionId={this.props.questionState.question.id}
                        />
                        <label for={"checkbox_yes_q" + this.props.questionState.question.id}>Yes &nbsp;&nbsp;&nbsp;</label>
                        <input
                            class="radio"
                            type="checkbox"
                            id={"checkbox_no_q" + this.props.questionState.question.id + 'qf' + this.props.questionState.questionFactStates[0].questionFactId}
                            checked={notNull && !isChecked}
                            ordinalEntry={0}
                            questionFactId={this.props.questionState.questionFactStates[0].questionFactId}
                            onChange={(evt) => this.handleChange(evt)}
                            value={false}
                            questionId={this.props.questionState.question.id}
                        /> <label for={"checkbox_no_q" + this.props.questionState.question.id}>No </label>
                    </div>
                </FormControl>
            }
        }
    }
}
export default BooleanRadioQuestion;

function UpdateAuditDialog(props) {
    const dialog = useDialog();

    let componentRef = null;
    let result = {};
    result.confirmed = false;

    return (
        <div>
            <div
                className={styles.updateAuditDialogOverlay}
                ref={(response) => (componentRef = response)}
            >
                <UpdateDialog
                    currentAnswer={props.currentAnswer}
                    booleanType={props.booleanType}
                    onChangeSourceOfData={(evt, newValue) => {
                        result.newValue = newValue;
                        result.sourceOfData = evt.target.value;
                    }}
                    onChangeReason={(evt, newValue) => {
                        result.newValue = newValue;
                        result.reason = evt.target.value
                    }}
                    onChangeNewValue={(evt) => {
                        result.newValue = evt.target.value
                    }}
                />
            </div>

            <div>
                <button
                    type="button"
                    className="btnBack"
                    onClick={(evt) => {
                        result.confirmed = false;
                        dialog.close(result);
                    }}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="btnNext"
                    onClick={(evt) => {
                        if (
                            result.sourceOfData === undefined || result.sourceOfData == null || result.sourceOfData.trim() == "" ||
                            result.reason === undefined || result.reason == null || result.reason.trim() == ""
                        ) {
                            SupportAlert.displayAlert('Required', 'Source of data and Reason are required fields.');
                        } else {
                            result.confirmed = true;
                            dialog.close(result);
                        }
                    }}
                >
                    Continue
                </button>
            </div>
        </div>
    );
}